import { useMemo } from "react";
import { Roles } from "../models/roles";
import { useAppSelector } from "../store";
import { computeMissingDocs } from "../utils/missingDocsHelper";

/**
 * Returns the list of required qualification document types that are missing
 * for the current candidate, computed from Redux onboarding state.
 *
 * Use this hook in components that only need to read missing docs from Redux.
 * For components using Formik form values (e.g. Qualifications step), call
 * computeMissingDocs() directly instead.
 */
export function useMissingDocs(): string[] {
 
  const user = useAppSelector((state) => state.auth.user);
  const isSuperAdmin =
      (user?.role?.name as Roles) === Roles.SUPER_ADMIN ||
      (user?.role?.name as Roles) === Roles.GENERAL_ADMIN;
  const candidateReviewData = useAppSelector((state) => state.superadmin.reviewCandidateData);
  const qualifications = useAppSelector((state) => isSuperAdmin ? state.superadmin.reviewCandidateData?.qualifications : state.onboarding.qualifications);
  const personaldetails = useAppSelector((state) => isSuperAdmin ? state.superadmin.reviewCandidateData?.profile : state.onboarding.personaldetails);
   

  return useMemo(
    () =>
      computeMissingDocs(
        qualifications as any,
        personaldetails?.working_rights,
        isSuperAdmin ? candidateReviewData?.documents : qualifications?.documents
      ),
    [qualifications, personaldetails]
  );
}
